import React, { useState, useEffect } from 'react';
import SubmenuList from './SubmenuList';
import HowToUse from './HowToUse';
import Howtousenew from './Howtousenew';
import FooterControl from './FooterControls';
import ReactDOM from 'react-dom';
import Features from './Features';
import QRCode from 'react-qr-code';
const Menu = (props) => {
   const [myJson, setMyJson] = useState([]);
   const [menuList, setMenuList] = useState([]);
   const [uiDataList, setuiDataList] = useState({});
   const [featureMenuList, setfeatureMenuList] = useState([]);
   const [openCloseOnOff, setOpenCloseOnOff] = useState(false);
   const [backliteOnOff, setBackliteOnOff] = useState(false);

   const [buttonArray, setbuttonArray] = useState([]);
   const [buttonArrayObjectList, setbuttonArrayObjectList] = useState([]);
   const [widthUpdate, setwidthUpdate] = useState(false);
   const [updatefeatureType, setupdatedfeatureType] = useState('wwan');
   const [productTitle, setProductTitle] = useState([]);
   const [productType, setproductType] = useState([]);
    let QRSupport = props.QRSupport;
   // setwidthUpdate(window.mob)
   let howtoUseD = false;
   const getData = () => {
      fetch('data.json'
         , {
            headers: {
               'Content-Type': 'application/json',
               'Accept': 'application/json'
            }
         }
      )
         .then(function (response) {
            return response.json();
         })
         .then(function (mydata) {
            return mydata;

         }).then(function (setmydata) {
            setMyJson(setmydata);
            document.title = setmydata.ProjectTitle;
            window.ProjectTitle = setmydata.ProjectTitle;

            // window.productId = setmydata.productId;
            window.selectedConfig.name = setmydata.productId;
            window.selectedConfig.currentFeatureTypewwan_wlan = `menu_id_${setmydata['currentFeatureTypewwan_wlan']}`
            window.selectedConfig.currentFeatureTypeFingerprint = `menu_id_${setmydata['currentFeatureTypeFingerprint']}`
            window.selectedConfig.currentFeatureTypeSmartCardReader = `menu_id_${setmydata['currentFeatureTypeSmartCardReader']}`
            window.selectedConfig.currentProductClick = `menu_id_${setmydata['currentProductClick']}`
            window.preActiveFeatureSubMenuIdOne = `menu_id_${setmydata['currentFeatureTypewwan_wlan']}`
            window.preActiveFeatureSubMenuIdTwo = `menu_id_${setmydata['currentFeatureTypeFingerprint']}`
            window.preActiveFeatureSubMenuIdThree = `menu_id_${setmydata['currentFeatureTypeSmartCardReader']}`
            window.preActiveCurrentProductClick = `menu_id_${setmydata['currentProductClick']}`
            window.currentAccordianActiveMenuID = `accordion_${setmydata['currentAccordianActiveMenu']}`;
            // console.log();
            let feature_list;
            let menuData;
            let productTypeData;
            let uiData;

            if (setmydata.menus[window.LangName] == undefined) {
               uiData = setmydata.menus.EN[0];

            } else {
               uiData = setmydata.menus[window.LangName][0];
            }
            window.dataUI = uiData;
            if (window.LangName && window.LangName in setmydata['menus'] && setmydata.LangugageTranslation) {
               menuData = setmydata.menus[window.LangName].filter(val => val.featureMenu === false && val.menuVisibility !== 'hide');
               feature_list = setmydata.menus[window.LangName].filter(val => val.featureMenu === true && val.menuVisibility !== 'hide');
               productTypeData = setmydata.menus[window.LangName].filter(val => val.menuVisibility !== 'hide' && val.id === "ProductType");
            }
            else {
               menuData = setmydata.menus.EN.filter(val => val.featureMenu === false && val.menuVisibility !== 'hide')
               // var mobProducts = menuData[0].items;
               feature_list = setmydata.menus.EN.filter(val => val.featureMenu === true && val.menuVisibility !== 'hide');
               productTypeData = setmydata.menus.EN.filter(val => val.menuVisibility !== 'hide' && val.id === "ProductType");

            }
            setMenuList(menuData);
            setuiDataList(uiData);
            setfeatureMenuList(feature_list)
            setproductType(productTypeData);
            setTimeout(() => {
               langTranslationAlignment(menuData);
            }, 1000);
            if (setmydata["accordianClick"]) {
               const setAllItems = () => {
                  const allItemsObj = menuData.flatMap((obj) => [
                     obj.id,
                     ...obj.items.map((item) => item.id),
                  ]);
                  setbuttonArray(allItemsObj);
               };
               setAllItems();
               const setAllAccordion = () => {
                  const allAccordionObj = menuData.flatMap((obj) => [
                     obj,
                     ...obj.items.map((item) => item),
                  ]);
                  setbuttonArrayObjectList(allAccordionObj);
               };
               setAllAccordion();

            } else {
               menuData.map((menu) => {
                  menu.items.map(item => {
                     if (item.id !== undefined) {
                        setbuttonArray((buttonArray) => [...buttonArray, item.id]);
                        setbuttonArrayObjectList((buttonArrayObjectList) => [...buttonArrayObjectList, item]);
                     }
                  })
               })
            }
         });
         
   }
    // Changes for QR code update
        if (window.location.href) {
           let url = window.location.href.split('?')[0];
           if (!url.endsWith('index.html')) {
           if (!url.endsWith('/')) url += '/';
               url += 'index.html';
        }
        let params = window.location.href.split('?')[1];
        let newParames = '?qr=1';
        if(params != undefined && !params.includes('qr=')){
            newParames = newParames+'&'+params;
        } else if(params != undefined && params.includes('qr=')){
            newParames = '?'+params;
        }

        url = url+newParames;

        /*Code for Content qr */
        if(params != undefined && params.includes('contentURL=')){
            let contentURL = params.split('contentURL=')[1];
            url = contentURL+'?qr=1';
        }
        /*Code for Content qr End*/
        

        
        
        /*Code for Content qr end */

        // if(window.ContentURLforQR != )

      //   window.linkForGenerateQR = `https://commondatastorage.googleapis.com/infinityrt_extranet_us/hmxmedia/test/Dell/dell-pro-pa14250-laptop/v4/index.html?qr=1&locale=zh-cn`;
     window.linkForGenerateQR = `${url}`;
      }
   const langTranslationAlignment = (menuData) => {
      if (window.dataUI) {
         document.querySelector('title').innerHTML = window.dataUI.ui.projectTitle;
         document.getElementById('move_text').innerHTML = window.dataUI.ui.move;
         document.getElementById('rotate_text').innerHTML = window.dataUI.ui.rotate;
         document.getElementById('zoom_text').innerHTML = window.dataUI.ui.zoom;
         document.getElementById('exploreButtton').innerHTML = window.dataUI.ui.exploreProductIn3D;

         const menutextFontSizeAccordian = (size) => {
            var menuText = document.querySelectorAll(".accordionContent .subMenu .subMenuBtn");
            menuText.forEach((item) => {
               item.style.fontSize = `${size}px`
            })
            var menuText = document.querySelectorAll(".accordionContainer .menu .text");
            menuText.forEach((item) => {
               item.style.fontSize = `${size}px`
            })
         };

         if (window.dataUI.ui.langcode == "fr") {
            document.getElementById("rotate_text").style.fontSize = '39px';
            setTimeout(() => {
               menutextFontSizeAccordian(14)
            }, 1000);
         }

         if (window.dataUI.ui.langcode == "pt-br") {
            setTimeout(function () {
                  menutextFontSizeAccordian(14)
            }, 0)
         }

         if (window.dataUI.ui.langcode == "fr-ca") {
            setTimeout(function () {
               document.querySelector("#rotate_text").style.width = '265px';
               document.querySelector("#rotate_text").style.display = 'inline-block';
               document.querySelector(".tooltiptext").style.width = '370px';
                  menutextFontSizeAccordian(14)
            }, 0)
         }

         if (window.dataUI.ui.langcode.toLowerCase() == "pl" || window.dataUI.ui.langcode.toLowerCase() == "nl" || window.dataUI.ui.langcode.toLowerCase() == "de") {
            setTimeout(function () {
               if (document.getElementById("howTousePopupDesk") !== null) {
                  document.getElementById("howTousePopupDesk").style.wordBreak = "break-all";
               }
            }, 1000);
         }

         if (window.dataUI.ui.langcode == "fr-ca" || window.dataUI.ui.langcode == "nl") {
            // alert();
            if (document.getElementById("mobHowToUseText") !== null) {
               document.getElementById("mobHowToUseText").style.fontSize = "30px";
            }
            if (document.getElementById("move_how_to_use") !== null) {
               document.getElementById("move_how_to_use").style.fontSize = "19px";
            }
            if (document.getElementById("rotate_how_to_use") !== null) {
               document.getElementById("rotate_how_to_use").style.fontSize = "19px";
            }
            if (document.getElementById("zoom_how_to_use") !== null) {
               document.getElementById("zoom_how_to_use").style.fontSize = "19px";
            }
         }
         if (window.dataUI.ui.langcode == "it") {
            setTimeout(function () {
               document.querySelector(".tooltiptext").style.width = '350px';
               menutextFontSizeAccordian(14)
            }, 0)
         }

         if (window.dataUI.ui.langcode.toLowerCase() === "ja" && !(window.mob || window.isipad)) {
            if (document.getElementById("accordionContainer") !== null) {
               document.getElementById("accordionContainer").style.width = "calc(68vw - 307px)";
            }
         }

         if (window.dataUI.ui.langcode.toLowerCase() === "de") {
            document.querySelector(".tooltiptext").style.width = '350px';
         }
         if (window.dataUI.ui.langcode.toLowerCase() === "ja") {
            document.querySelector(".tooltiptext").style.width = '320px';
         }

         if (window.dataUI.ui.langcode.toLowerCase() === "pl" || window.dataUI.ui.langcode.toLowerCase() === "pt-br" || window.dataUI.ui.langcode.toLowerCase() === "fr" || window.dataUI.ui.langcode.toLowerCase() == "es" || window.dataUI.ui.langcode.toLowerCase() === "ja" || window.dataUI.ui.langcode == "sv") {
            document.querySelector(".tooltiptext").style.width = '350px';
         }

         if (window.dataUI.ui.langcode.toLowerCase() === "fr-ca" || window.dataUI.ui.langcode.toLowerCase() === "no" || window.dataUI.ui.langcode.toLowerCase() === "es") {
            setTimeout(function () {
               document.querySelector("#rotate_text").style.display = 'inline-block';
            }, 0);

         }

         // if (window.isipad && window.innerHeight < window.innerWidth) {
         //    if (window.dataUI.ui.langcode == "it" || window.dataUI.ui.langcode == "fr" || window.dataUI.ui.langcode == "fr-ca" || window.dataUI.ui.langcode == "pt-br") {
         //       setTimeout(function () {
         //          menutextFontSizeAccordian(14)
         //       }, 1000)
         //    }
         // }


         if (window.mob && window.innerHeight > window.innerWidth) {
            if (window.dataUI.ui.langcode == "es") {
               setTimeout(function () {
                  document.querySelector("#zoom_text").style.textAlign = 'left';
                  document.querySelector("#move_text").style.textAlign = 'left';
                  document.querySelector("#rotate_text").style.textAlign = 'left';
                  document.querySelector("#zoom_text").style.width = '200px';
                  document.querySelector("#zoom_text").style.display = 'inline-block';
               }, 0);

            } 
            if (window.dataUI.ui.langcode.toLowerCase() == "fr-ca") {
               setTimeout(function () {
                  document.querySelector(".portraitButtonText").style.width = '80%';
                  document.querySelector(".portraitButtonText").style.marginTop = '5px';
               }, 0);

            }

            if (window.dataUI.ui.langcode.toLowerCase() == "it") {
               setTimeout(function () {
                  document.querySelector("#mobHowToUseText").style.top = '-50%';
               }, 0);

            }


            if (window.dataUI.ui.langcode.toLowerCase() == "pl") {
               setTimeout(function () {
                  if (document.getElementById("move_how_to_use") !== null) {
                     document.getElementById("move_how_to_use").style.fontSize = "18.5px";
                  }
                  if (document.getElementById("rotate_how_to_use") !== null) {
                     document.getElementById("rotate_how_to_use").style.fontSize = "18.5px";
                  }
                  if (document.getElementById("zoom_how_to_use") !== null) {
                     document.getElementById("zoom_how_to_use").style.fontSize = "18.5px";
                  }
               }, 0);
            }
            if (window.dataUI.ui.langcode.toLowerCase() == "fr-ca" || window.dataUI.ui.langcode.toLowerCase() == "fr") {
               setTimeout(function () {
                  document.querySelector("#zoom_text").style.fontSize = "37px"
                  document.querySelector("#move_text").style.fontSize = "37px"
                  document.querySelector("#rotate_text").style.fontSize = "37px"
                  document.querySelector("#rotate_text").style.display = 'inline-block';
                  document.querySelector("#rotate_text").style.width = '202px';
               }, 0);
            }
         }


         if (window.mob && window.innerHeight > window.innerWidth || window.isipad && window.innerHeight > window.innerWidth) {
            if (window.dataUI.ui.langcode.toLowerCase() === "es" || window.dataUI.ui.langcode.toLowerCase() === "de") {
               setTimeout(function () {
                  document.querySelector("#mobHowToUseText").style.fontSize = '36px';
                  document.querySelector("#mobHowToUseText").style.top = '-17%';
               }, 0);
            }
            if (window.dataUI.ui.langcode.toLowerCase() === "de") {
               setTimeout(function () {
                  if (document.getElementById("move_text") !== null) {
                     document.getElementById("move_text").style.fontSize = "33px";
                  }
                  if (document.getElementById("rotate_text") !== null) {
                     document.getElementById("rotate_text").style.fontSize = "33px";
                  }
                  if (document.getElementById("zoom_text") !== null) {
                     document.getElementById("zoom_text").style.fontSize = "33px";
                  }
               }, 0);
            }

            //This is for onload screen for mobile UI
            if (window.dataUI.ui.langcode.toLowerCase() === "pl") {
               setTimeout(function () {
                  document.querySelector("#mobHowToUseText").style.fontSize = '36px';

                  if (document.getElementById("move_text") !== null) {
                     document.getElementById("move_text").style.fontSize = "30px";
                  }
                  if (document.getElementById("rotate_text") !== null) {
                     document.getElementById("rotate_text").style.fontSize = "30px";
                  }
                  if (document.getElementById("zoom_text") !== null) {
                     document.getElementById("zoom_text").style.fontSize = "30px";
                  }
               }, 0);

            }

            if (window.dataUI.ui.langcode.toLowerCase() === "pl" || window.dataUI.ui.langcode.toLowerCase() === "de" || window.dataUI.ui.langcode.toLowerCase() === "es") {
               setTimeout(function () {
                  document.querySelector("#mobHowToUseText").style.top = '-16%';
               }, 0);

            }
         }

      }
   }
   useEffect(() => {
      const menuref = document.querySelector('.menuContainer');
      window.mainMenuRef = menuref;
   })

   useEffect(() => {
      setTimeout(() => {
         getData();
      }, 1000);

   }, [])

   window.checkWindowSize = function () {
      setwidthUpdate(window.mob)
   }

   const menuExpandCollaps = () => {
      var mainMenu = window.mainMenuRef;
      var mainMenuClass = mainMenu.classList;
      if (mainMenuClass.contains("collapsed")) {
         mainMenu.classList.remove('collapsed');
         mainMenu.classList.add('expanded');
      } else {
         mainMenu.classList.add('collapsed');
         mainMenu.classList.remove('expanded');
         var getExpandedAccordion = document.querySelectorAll('.menu.active');
         if (getExpandedAccordion.length !== 0) {
            for (var i = 0; i <= getExpandedAccordion.length; i++) {
               if (getExpandedAccordion[i] !== undefined) {
                  getExpandedAccordion[i].classList.remove('active');
                  getExpandedAccordion[i].nextSibling.style.height = '0px';
               }
            }
         }
      }

   }
   const howToUSEClick = (e) => {

      const howtoUseTabIndex = document.querySelector("#howToUSE");
      const childrenWithTabIndex = howtoUseTabIndex.querySelectorAll('[tabindex]');
      document.querySelector('#howToUSE').focus();

      if (howtoUseD) {
         childrenWithTabIndex.forEach(child => {
            child.setAttribute('tabindex', '-1');
         });
         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#006BBD";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');

         howtoUseD = false;
      } else {
         childrenWithTabIndex.forEach(child => {
            child.setAttribute('tabindex', '1');
         });
         document.getElementById('howToUSE').style.opacity = "1";
         if (window.isipad && window.innerWidth > window.innerHeight) {
            document.getElementById('howToUSE').style.marginTop = "2.7%";

         } else {
            document.getElementById('howToUSE').style.marginTop = "-1%";

         }
         document.getElementById('howToUSE').style.animationName = "example1";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#0076CE";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#FFFFFF";
         document.getElementById('howToUseMenu').firstChild.classList.add('active');

         howtoUseD = true;
      }
   }
   const closeHandle = (event) => {
      const howtoUseTabIndex = document.querySelector("#howToUSE");
      const childrenWithTabIndex = howtoUseTabIndex.querySelectorAll('[tabindex]');
      event && event.preventDefault();
      if (document.getElementById('howToUSE')) {
         childrenWithTabIndex.forEach(child => {
            child.setAttribute('tabindex', '-1');
         });
         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#006BBD";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');

         howtoUseD = false;
      }

   };

   const closeHandleMenu = (event) => {
      //TabIndex Click Functionality
      const howtoUseTabIndex = document.querySelector("#howToUSE");
      const childrenWithTabIndex = howtoUseTabIndex.querySelectorAll('[tabindex]');
      event && event.preventDefault();
      if (document.getElementById('howToUSE')) {
         childrenWithTabIndex.forEach(child => {
            child.setAttribute('tabindex', '-1');
         });
         document.querySelector('#howToUseMenu').focus();
         document.getElementById('howToUSE').style.opacity = "0";
         document.getElementById('howToUSE').style.marginTop = "-100%";
         document.getElementById('howToUSE').style.animationName = "example";
         document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#FFFFFF";
         document.getElementsByClassName('HowToUseHeader')[0].lastChild.style.color = "#006BBD";
         document.getElementById('howToUseMenu').firstChild.classList.remove('active');


         howtoUseD = false;
      }
   };

   const accordionMenu = (e) => {

      clearInterval(window.touchLEDClear);
      //Accessibility 

      //make tabIndex -1
      let subMenuTabIndex1 = document.querySelectorAll(".subMenuBtn[tabIndex='1']");
      let subMenuTabIndex1Arr = [...subMenuTabIndex1];
      // console.log('subMenuTabIndex1Arr', subMenuTabIndex1Arr);
      subMenuTabIndex1Arr.forEach(ele => {
         ele.setAttribute("tabIndex", "-1");
      });


      let subMenu = document.querySelectorAll(".subMenuBtn.list")
      subMenu.forEach((item) => {
         // item.classList.remove('active');
      })

      window.hidePopUp();
      var mainMenu = window.mainMenuRef;
      var mainMenuClass = mainMenu.classList;

      myJson.menus.EN.map((menu_Item) => {
         if ("accordion_" + menu_Item['id'] === e.target.closest('.menu').id) {
            return window.execute_all(menu_Item);

         }
      })

      setTimeout(function () {
         var allPopup = document.querySelector('.popup.active');
         if (allPopup != null) {
            allPopup.classList.remove('active');
         }
      }, 500)

      if (mainMenuClass.contains("collapsed")) {
         mainMenu.classList.remove('collapsed');
         mainMenu.classList.add('expanded');
      }

      if (e.target.closest('.menu').classList.contains('active')) {
         if ((!window.mob && window.innerWidth > window.innerHeight)) {
            e.target.closest('.menu').classList.remove('active');
            e.target.closest('.menu').nextSibling.style.height = '0px';
         }
      }
      else {
         var menu_active = document.querySelectorAll('.menu');
         for (var i = 0; i <= menu_active.length - 1; i++) {
            if (menu_active[i].id !== 'howToUseMenu') {
               menu_active[i].classList.remove('active')
               menu_active[i].nextSibling.style.height = '0px';
            }
         }

         e.target.closest('.menu').classList.add('active');
         window.selectedButtonType = e.target.closest('.menu').id;
         var accordionContent = e.target.closest('.menu').nextSibling.firstChild;
         if (accordionContent != null) {
            e.target.closest('.menu').nextSibling.style.height = accordionContent.offsetHeight + 'px';
         }

         //make tabIndex 1
         let currentTargetAccordion = e.target.closest('.menu.active')
         let currentTargetAccordionSubMenu = currentTargetAccordion.nextSibling;
         let subMenuElement = currentTargetAccordionSubMenu.querySelectorAll('.subMenuBtn');
         let subMenuElementArr = [...subMenuElement];
         // console.log('currentTargetAccordionSubMenu', currentTargetAccordionSubMenu);
         // console.log('subMenuElement', subMenuElement);
         subMenuElementArr.forEach(ele => {
            ele.setAttribute("tabIndex", "1");
         });

      }

      if (orentation === 90) {
         closeHandle();
      }

      var selectedSubMenu = document.querySelectorAll('.subMenuBtn');
      for (var i = 0; i <= selectedSubMenu.length - 1; i++) {
      }
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
      }
   }
   const subMenu = (e) => {

      var selectedSubMenu = document.querySelectorAll('.subMenuBtn');
      for (var i = 0; i <= selectedSubMenu.length - 1; i++) {
         selectedSubMenu[i].classList.remove('active')
      }
      e.target.classList.add('active');
   }
   var data1 = {
      method: accordionMenu,
      method2: howToUSEClick,
      method3: subMenu,
   }
   const handleTransitions = (e) => {
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked === true) {
         window.animationStatus = 'on';

      } else {
         window.animationStatus = 'off';

      }

   }
   const handleTransitionskeyPress = (e) => {
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked === true) {
         window.animationStatus = 'off';
         document.getElementById("animSwitchValue").checked = false;
      } else {
         window.animationStatus = 'on';
         document.getElementById("animSwitchValue").checked = true;

      }

   }
   var animStopped = true;

   const conScreenControlHandler = (e) => {

      const isChecked = document.getElementById("onScreenControlsValue").checked;
      if (isChecked === true) {
         window.animation1SwitchGlobal = 'on';
         window.animationSwitchVal = 'on';

         if (window.mob && !window.isipad) {

            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {

            if (window.innerWidth > window.innerHeight) {
               document.getElementById('footerControls').style.display = 'block';
               document.getElementById('footerControls').style.bottom = "55px";
            } else {
               document.getElementById('footerControls').style.display = 'none';
            }
         } else {

            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "1");
            }
            document.getElementById('footerControls').style.bottom = "55px";
         }


      } else {
         window.animation1SwitchGlobal = 'off';
         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            document.getElementById('footerControls').style.bottom = "-155px";
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "-1");
            }
            setTimeout(function () {


               animStopped = true;
            }, 200);
         }

      }

   }

   const conScreenControlHandlerkeyPress = (e) => {

      const isChecked = document.getElementById("onScreenControlsValue").checked;
      if (isChecked === false) {
         window.animation1SwitchGlobal = 'on';
         window.animationSwitchVal = 'on';

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         }
         else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'block';
         }
         else {
            document.getElementById('footerControls').style.bottom = "55px";
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "1");
            }
            document.getElementById("onScreenControlsValue").checked = true;
         }


      } else {
         window.animation1SwitchGlobal = 'off';

         if (window.mob) {
            document.getElementById('footerControls').removeAttribute('style');
         } else if (window.isipad) {
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            document.getElementById('footerControls').style.bottom = "-155px";
            document.getElementById("onScreenControlsValue").checked = false;
            var navBtn = document.querySelectorAll('.navBtn');
            for (var i = 0; i <= navBtn.length - 1; i++) {
               navBtn[i].setAttribute("tabindex", "-1");
            }
            setTimeout(function () {

               animStopped = true;
            }, 200);
         }

      }

   }

    // menu visiblity
    const handleSideMenuListVisibility = (menu_id,menu_type) => {
      // console.log(menu_id)
         if (menu_id == "touch") {
            // debugger
            let isPositionViewExist = menuList.find(item => item.id === "positionView")
            // console.log("isPositionViewExist", isPositionViewExist);
            let finalUpdatedMenuList;
   
         }
         else if (menu_id === "non_touch") {
            let totalMenu = myJson.menus[window.LangName];
            const changeMenuItems = totalMenu.find(item => item.id === "positionView");
            const updatedMenuItems = { ...changeMenuItems,menuVisibility: "hide" }
   
            const removedPositionView = totalMenu.filter(item => item.id !== "positionView");
   
            let removedConfigurationListID = ["smartCardReader","noSmartCardReader"];
            const changedMenu3 = removedPositionView.find(item => item.id === "configuration");
            const changeMenuItems3 = removedPositionView.find(item => item.id === "configuration").items;
            const updatedMenuItems3 = changeMenuItems3.map(item => removedConfigurationListID.includes(item.id) ? { ...item,subMenuVisibility: false } : item);
            const updatedMenu3 = { ...changedMenu3,items: updatedMenuItems3 };
   
            let removedConfigurationList = removedPositionView.filter(item => item.id !== "configuration");
   
            // let updatedMenuLIst = [removedConfigurationList[1],removedConfigurationList[2],removedConfigurationList[3],updatedMenu3]
            let updatedMenuLIst = [removedConfigurationList[1],removedConfigurationList[2],updatedMenu3]
            // console.log(updatedMenuLIst)
            setMenuList(updatedMenuLIst);
            langTranslationAlignment(updatedMenuLIst);
            let tempBtnArray = [];
   
            let tempbuttonArrayObjectList = [];
            updatedMenuLIst.map((menu) => {
               menu.items.map(item => {
                  if (item.id !== undefined) {
                     tempBtnArray = [...tempBtnArray,item.id];
                  }
                  tempbuttonArrayObjectList = [...tempbuttonArrayObjectList,item]
               })
            })
            setbuttonArray(tempBtnArray);
            setbuttonArrayObjectList(tempbuttonArrayObjectList);
   
   
         }
   }

   const handleMenuClick = (menu_object, e) => {

      let cameraId = menu_object['id'];
      let cameraName = menu_object['cameraName'];
      let cameraType = menu_object['type'];
      let productType = cameraType;
      let productTypecheck = menu_object['type'];
      
      if (menu_object.sequenceName) window.scene.applySequence(window[menu_object.sequenceName])

      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);
      window.hidePopUp();
      window.currID = menu_object['id'];

      if (productType == "configuration" && menu_object['featureType'] != "fingerprint") {
         window.featureType = menu_object['featureType'];
         if ((window.mob || window.isipad) && window.innerWidth < window.innerHeight) {
            setupdatedfeatureType(window.featureType);
         }
      }

      if (productTypecheck == "ProductType") {
         window.productName = menu_object['id'];
         window.itCameraType = menu_object['id'];
         if ((window.mob || window.isipad) && window.innerWidth < window.innerHeight) {
            // setupdatedProductId(window.productName);
         }
         // code for menu hide/show
         // handleSideMenuListVisibility(cameraId,cameraType)
      }

      window.execute_all(menu_object);
      setMenuActive(cameraId, cameraType, e);
      if (orentation === 90) {
         closeHandle();
      }
   }

   const setMenuActive = (menu_id, menu_type, e) => {
      if (menu_type === 'configuration' && (menu_id === "fpr" || menu_id === "noFpr")) {
         const prefprActive = document.querySelector('.radioButton.fprActive');
         if (prefprActive) {
            prefprActive.classList.remove('fprActive')
            prefprActive.querySelector('input').checked = false;
         }

         const featureModeBtn = document.getElementById(`menu_id_${menu_id}`);
         window.selectedConfig.currentFeatureTypeFingerprint = featureModeBtn.id;
         if (featureModeBtn) {
            featureModeBtn.classList.add('fprActive')
            featureModeBtn.querySelector('input').checked = true;
         }
         if ((window.mob || window.isipad) && window.innerHeight > window.innerWidth) {
            setTimeout(() => {
               const featureModeBtn = document.getElementById(`menu_id_${menu_id}`);
               window.selectedConfig.currentFeatureTypeFingerprint = featureModeBtn.id;
               // console.log(featureModeBtn)
               if (featureModeBtn) {
                  featureModeBtn.classList.add('fprActive')
                  featureModeBtn.querySelector('input').checked = true;
               }
               var previousFeatureACtive = document.getElementById(window.selectedConfig.currentFeatureTypewwan_wlan)
               if (previousFeatureACtive) {
                  previousFeatureACtive.classList.add('featureModeActive')
               }
               var previousCardACtive = document.getElementById(window.selectedConfig.currentFeatureTypeSmartCardReader)
               if (previousCardACtive) {
                  previousCardACtive.classList.add('cardActive')
               }
            }, 0);

         }
      } else if (menu_type === 'configuration' && (menu_id === "smartCardReader" || menu_id === "noSmartCardReader")) {
         const preCardActive = document.querySelector('.radioButton.cardActive');
         if (preCardActive) {
            preCardActive.classList.remove('cardActive')
            preCardActive.querySelector('input').checked = false;
         }

         const featureModeBtn = document.getElementById(`menu_id_${menu_id}`);
         window.selectedConfig.currentFeatureTypeSmartCardReader = featureModeBtn.id;

         const prefeatureModeActive = document.querySelector('.radioButton.featureModeActive');
         // if (prefeatureModeActive) {
         //    prefeatureModeActive.classList.remove('featureModeActive')
         //    prefeatureModeActive.querySelector('input').checked = false;
         // }
         // if (document.getElementById(window.selectedConfig.currentFeatureTypeSmartCardReader) != undefined) {
         //    if (window.selectedConfig.currentFeatureTypeSmartCardReader == 'menu_id_smartCardReader') {
         //       window.selectedConfig.currentFeatureTypewwan_wlan = 'menu_id_wwanBack';
         //       document.getElementById(window.selectedConfig.currentFeatureTypewwan_wlan).classList.add('featureModeActive')
         //       document.getElementById(window.selectedConfig.currentFeatureTypewwan_wlan).querySelector('input').checked = true;
         //    }
         //    else if (window.selectedConfig.currentFeatureTypeSmartCardReader == 'menu_id_noSmartCardReader') {
         //       window.selectedConfig.currentFeatureTypewwan_wlan = 'menu_id_wlanBack';
         //       document.getElementById(window.selectedConfig.currentFeatureTypewwan_wlan).classList.add('featureModeActive')
         //       document.getElementById(window.selectedConfig.currentFeatureTypewwan_wlan).querySelector('input').checked = true;
         //    }
         // }

         if (featureModeBtn) {
            featureModeBtn.classList.add('cardActive')
            featureModeBtn.querySelector('input').checked = true;
         }

         if ((window.mob || window.isipad) && window.innerHeight > window.innerWidth) {
            setTimeout(() => {
               const featureModeBtn = document.getElementById(`menu_id_${menu_id}`);
               window.selectedConfig.currentFeatureTypeSmartCardReader = featureModeBtn.id;
               if (featureModeBtn) {
                  featureModeBtn.classList.add('cardActive')
                  featureModeBtn.querySelector('input').checked = true;
               }

               var previousFeatureACtive = document.getElementById(window.selectedConfig.currentFeatureTypewwan_wlan)
               if (previousFeatureACtive) {
                  previousFeatureACtive.classList.add('featureModeActive')
                  //    featureModeBtn.querySelector('input').checked = true;
               }
               var previousfprActive = document.getElementById(window.selectedConfig.currentFeatureTypeFingerprint)
               if (previousfprActive) {
                  previousfprActive.classList.add('fprActive')
                  //    featureModeBtn.querySelector('input').checked = true;
               }

            }, 0);

         }

      }
      else if (menu_type === 'configuration') {
         const prefeatureModeActive = document.querySelector('.radioButton.featureModeActive');
         if (prefeatureModeActive) {
            prefeatureModeActive.classList.remove('featureModeActive')

            prefeatureModeActive.querySelector('input').checked = false;
         }

         const featureModeBtn = document.getElementById(`menu_id_${menu_id}`);

         window.selectedConfig.currentFeatureTypewwan_wlan = featureModeBtn.id;
         // const preCardActive = document.querySelector('.radioButton.cardActive');
         // if (preCardActive) {
         //    preCardActive.classList.remove('cardActive')
         //    preCardActive.querySelector('input').checked = false;
         // }
         // if (document.getElementById(window.selectedConfig.currentFeatureTypeSmartCardReader) != undefined) {
         //    if (window.selectedConfig.currentFeatureTypewwan_wlan == 'menu_id_wwanBack') {
         //       window.selectedConfig.currentFeatureTypeSmartCardReader = 'menu_id_smartCardReader';
         //       document.getElementById(window.selectedConfig.currentFeatureTypeSmartCardReader).classList.add('cardActive')
         //       document.getElementById(window.selectedConfig.currentFeatureTypeSmartCardReader).querySelector('input').checked = true;
         //    }
         //    else if (window.selectedConfig.currentFeatureTypewwan_wlan == 'menu_id_wlanBack') {
         //       window.selectedConfig.currentFeatureTypeSmartCardReader = 'menu_id_noSmartCardReader';
         //       document.getElementById(window.selectedConfig.currentFeatureTypeSmartCardReader).classList.add('cardActive')
         //       document.getElementById(window.selectedConfig.currentFeatureTypeSmartCardReader).querySelector('input').checked = true;
         //    }
         // }

         if (featureModeBtn) {
            featureModeBtn.classList.add('featureModeActive')
            featureModeBtn.querySelector('input').checked = true;
         }

         if ((window.mob || window.isipad) && window.innerHeight > window.innerWidth) {
            
            setTimeout(() => {
               const featureModeBtn = document.getElementById(`menu_id_${menu_id}`);
               window.selectedConfig.currentFeatureTypewwan_wlan = featureModeBtn.id;
               if (featureModeBtn) {
                  featureModeBtn.classList.add('featureModeActive')
                  featureModeBtn.querySelector('input').checked = true;

               }
               var previousCardACtive = document.getElementById(window.selectedConfig.currentFeatureTypeSmartCardReader)
               if (previousCardACtive) {
                  previousCardACtive.classList.add('cardActive')
                  //    featureModeBtn.querySelector('input').checked = true;
               }

               var previousfprActive = document.getElementById(window.selectedConfig.currentFeatureTypeFingerprint)
               if (previousfprActive) {
                  previousfprActive.classList.add('fprActive')
                  //    featureModeBtn.querySelector('input').checked = true;
               }

            }, 0);
         }

      } else if (menu_type === 'ProductType') {
         const prefeatureModeActive = document.querySelector('.radioButton.featureModeActive');
         const prefprActive  = document.querySelector('.radioButton.fprActive ');
         const precardActive  = document.querySelector('.radioButton.cardActive ');
         const preProductActive = document.querySelector('.radioButton.productModeactive');
         if (preProductActive) {
            preProductActive.classList.remove('productModeactive')
            preProductActive.querySelector('input').checked = false;
         }
         // if (prefeatureModeActive) {
         //    prefeatureModeActive.classList.remove('featureModeActive')
         //    prefeatureModeActive.querySelector('input').checked = false;
         // }
         // if (prefprActive) {
         //    prefprActive.classList.remove('fprActive')
         //    prefprActive.querySelector('input').checked = false;
         // }
         // if (precardActive) {
         //    precardActive.classList.remove('cardActive')
         //    precardActive.querySelector('input').checked = false;
         // }
         const productModeBtn = document.getElementById(`menu_id_${menu_id}`);
         window.selectedConfig.currentProductClick = productModeBtn.id;
         if (productModeBtn) {
            productModeBtn.classList.add('productModeactive')
            productModeBtn.querySelector('input').checked = true;
         }

         setTimeout(() => {
            const selectActiveProduct = document.getElementById(`menu_id_${menu_id}`);
            window.selectedConfig.currentProductClick = selectActiveProduct.id;
            if (selectActiveProduct) {
               selectActiveProduct.classList.add('productModeactive')
               // selectActiveProduct.querySelector('input').checked = true;

            }
            window.selectedConfig.currentFeatureClick = window.preActiveFeatureSubMenuIdOne;
            window.selectedConfig.currentFeatureFPRClick = window.preActiveFeatureSubMenuIdTwo;
            window.selectedConfig.currentFeatureCardClick = window.preActiveFeatureSubMenuIdThree;

            // if (document.getElementById(window.preActiveFeatureSubMenuIdOne)) {
            //    document.getElementById(window.preActiveFeatureSubMenuIdOne).classList.add('featureModeActive')
            // }

            // if (document.getElementById(window.preActiveFeatureSubMenuIdTwo)) {
            //    document.getElementById(window.preActiveFeatureSubMenuIdTwo).classList.add('fprActive')
            // }

            // if (document.getElementById(window.preActiveFeatureSubMenuIdThree)) {
            //    document.getElementById(window.preActiveFeatureSubMenuIdThree).classList.add('cardActive')
            // }
            
            if ((window.mob || window.isipad) && window.innerHeight > window.innerWidth) {
               
               
            }


         },100);
      }


      let currentClass;
      let preActive;
      var currentActive;
      if (e != undefined) {
         currentActive = e.target.closest('li.subMenuBtn');
         currentClass = currentActive?.classList[0];
         preActive = document.querySelector('.' + currentClass + '.active');
         if ((window.mob || window.isipad) && window.innerHeight > window.innerWidth) {
            if (preActive?.id == currentActive?.id) {
               setTimeout(() => {
                  currentActive?.classList.remove('active')
               }, 100);
            } else {
               currentActive?.classList.add('active');
               preActive?.classList.remove('active')
            }
         } else {
            preActive?.classList.remove('active');
            currentActive?.classList.add('active');
         }
      }
      else {

         if (document.getElementById('menu_id_' + menu_id) != null) {
            currentActive = document.getElementById('menu_id_' + menu_id);
            currentClass = currentActive.classList[0];
            preActive = document.querySelector('.' + currentClass + '.active');

            if (preActive != null) {
               preActive.classList.remove('active');
            }


            if ((window.mob || window.isipad) && window.innerHeight > window.innerWidth) {
               if (preActive?.id == currentActive?.id) {
                  // console.log(currentActive,"currentActive")
                  setTimeout(() => {
                     currentActive.classList.remove('active')
                  }, 100);
               } else {
                  currentActive.classList.add('active')
               }
            } else {

               currentActive.classList.add('active');
            }
         }
      }

      window.selectedConfig.currentSubMenuClick = currentActive.id;
      window.selectedButton = menu_id;
      window.checkedButton = menu_id;
      window.selectedButtonType = menu_type;
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
      }
   }




//skip next previous port 
let skipNextPreviousPortArrId = ["touch","non_touch"];

const onPreviousMode = () => {
   setTimeout(() => {
      if (document.querySelector('.subHeadingText')) {
         document.querySelector('.subHeadingText').classList.add(window.dataUI.ui.langcode)
      }
   }, 10);

   window.hidePopUp();
   var center = [0, 0, 0];
   window.scene._nav.SetRotationCenter(center);

   let cameraName;
   window.updateSlider();
   let finalButtonArray = buttonArray.filter(item => !skipNextPreviousPortArrId.includes(item));

   var prevButton;
   var selectedButtonIndex = finalButtonArray.findIndex(element => element === window.checkedButton)
   if (!window.AnimComplated) {
      return
   }
   if (window.checkedButton == 'onResetMode' || window.checkedButton == '') {
      prevButton = finalButtonArray[finalButtonArray.length - 1];
   } else {

      prevButton = finalButtonArray[selectedButtonIndex - 1];
   }

   if (prevButton == undefined) { prevButton = finalButtonArray[finalButtonArray.length - 1] }

   let result = buttonArrayObjectList.find(object => object.id == prevButton);
   // if (window.selectedButtonType !== result['type']) {
   //    expandMenu(`accordion_${result['type']}`);
   // }

   if (result !== undefined) {
      expandMenu(`accordion_${result['type']}`);
   }

   if (result['id'] === "OpenCloseLid") {
      window.open_close_status = window.open_close_status === "off" ? "on" : "off"
   }

   // if (window.productType != "colors") {
   //    window.storeViewID = result['id']
   // }

   //added condition for backlit keyboard functionality
   if (result['id'] === "BacklitKeyboard") {
      window.backlit_keyboard_status = window.backlit_keyboard_status === "off" ? "on" : "off"
   }

   window.execute_all(result);
   setMenuActive(result['id'], result['type']);


   return false;

}
const onNextMode = () => {
   window.hidePopUp();
   setTimeout(() => {
      if (document.querySelector('.subHeadingText')) {
         document.querySelector('.subHeadingText').classList.add(window.dataUI.ui.langcode)
      }
      
   }, 10);
   var center = [0, 0, 0];
   window.scene._nav.SetRotationCenter(center);
   let cameraName;
   window.updateSlider();
   //created this finalButtonArray to skip the color views
   let finalButtonArray = buttonArray.filter(item => !skipNextPreviousPortArrId.includes(item));
   var nextButton;
   var selectedButtonIndex = finalButtonArray.findIndex(element => element === window.checkedButton)
   if (!window.AnimComplated) {
      return
   }
   if (window.checkedButton === 'onResetMode' || window.checkedButton === '') {
      nextButton = finalButtonArray[0];

   } else {
      nextButton = finalButtonArray[selectedButtonIndex + 1];
   }
   if (nextButton === undefined) { nextButton = finalButtonArray[0] }

   let result = buttonArrayObjectList.find(object => object.id === nextButton);

   // if (window.selectedButtonType !== result['type']) {

   //    expandMenu(`accordion_${result['type']}`);
   // }

   if (result !== undefined) {
      expandMenu(`accordion_${result['type']}`);
   }

   if (result['id'] === "OpenCloseLid") {
      window.open_close_status = window.open_close_status === "off" ? "on" : "off"
   }
   if (window.productType != "colors") {
      window.storeViewID = result['id']
   }

   //added condition for backlit keyboard functionality
   if (result['id'] === "BacklitKeyboard") {
      window.backlit_keyboard_status = window.backlit_keyboard_status === "off" ? "on" : "off"
   }

   window.execute_all(result);
   setMenuActive(result['id'], result['type']);

   return false;

}
   const onReset = () => {
      
      var center = [0, 0, 0];
      window.scene._nav.SetRotationCenter(center);

     
      window.updateSlider();
      if (!window.AnimComplated) {
         return;
      }
      let nextButton;
      if (window.checkedButton === 'onResetMode' || window.checkedButton === '' || window.checkedButton === undefined) {
         window.scene.applySequence(window[window.config.resetSequence]);
      }
      else if (window.checkedButton === 'productView') {
         window.scene.applySequence(window[window.config.resetSequence]);
      }
      else if (window.checkedButton === 'features') {
         nextButton = 'FunctionMode'
      }
      else {
         nextButton = window.checkedButton;
      }
      let result = buttonArrayObjectList.find(object => object.id === nextButton);
      if (window.checkedButton !== 'onResetMode' || window.checkedButton !== '') {
         if (result !== undefined) {
            expandMenu(`accordion_${result['type']}`);
         }
      }
      if (result !== undefined) {
         window.execute_all(result);
         setMenuActive(result['id'], result['type']);
      }
      
   }

   const expandMenu = (menuId) => {
      if (document.querySelector('.menu.active') != null) {
         document.querySelector('.menu.active').classList.remove('active');
         var accordionContentAll = document.querySelectorAll('.accordionContent');

         for (var i = 0; i <= accordionContentAll.length - 1; i++) {
            accordionContentAll[i].style.height = '0px';
         }
      }

      var accordionContent = document.getElementById(menuId).nextSibling.firstChild;
      if (accordionContent != null) {

         document.getElementById(menuId).classList.add('active')

         document.getElementById(menuId).nextSibling.style.height = accordionContent.offsetHeight + 'px';
      }

   }
   const howToUseMobClick = () => {
      document.getElementById('howToUSE').style.display = "block";
      document.getElementById('howTousePopup').style.display = "block";
      document.getElementsByClassName('HowToUseHeader')[0].style.backgroundColor = "#0076CE";
      document.getElementsByClassName('HowToUseHeader')[0].style.color = "#FFFFFF";
      document.getElementById('howToUSE').style.zIndex = "12";
      document.getElementById('howTousePopup').style.zIndex = "2";
   }
   const [orentation, setOrentation] = useState(window.innerHeight > window.innerWidth ? 0 : 90)


   const arbuttonName = ((navigator.userAgent.indexOf("iPhone") != -1) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15") || window.detectIpadDevice()) || (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (navigator.userAgent.indexOf("iPhone") == -1)) ? 'btnXR-iphone' : 'btnXR';

   const TowerClick = (menuData) => {
      window.execute_all(menuData[0].items[0]);
   }

   //This code is for how to use component resize issue
   const CanvasResizeFunction = () => {
      if (window.innerHeight > window.innerWidth) {
         setOrentation(0)
      } else if (window.innerWidth > window.innerHeight) {
         setOrentation(90)
      } else {
         setOrentation((item) => {
            return item;
         })
      }
   }
   window.addEventListener('resize', CanvasResizeFunction)
   const { howToUSE, ReduceTransitions, onScreenControls, hovertext, QR, arMob } = { ...uiDataList.ui }
   // console.log(menuList,'menulist-----------')
   return (
      <>
         <div className='leftMenuWrapper' id='leftMenuWrapper'>
            <div id='mainMenu' className='menuContainer expanded'>
                <div className='portraitButton' id={arbuttonName} style={arbuttonName === 'btnXR' ? { 'display': 'none' } : {}}>
            <span className='portraitButtonText' id="portraitButtonTextId">{uiDataList.ui?.arMob}</span>
               </div> 
               <div className={`howToUseMob `} id="howToUseMob" onClick={howToUseMobClick} >
                  <span className='portraitButtonText'>{uiDataList.ui?.howToUSE}</span>
               </div>

               <div id="howToUseMenu" tabIndex="-1" className='menu noDropDown HowToUseHeader' onClick={data1.method2} onKeyDown={(e) => {
                  if (e.key !== 'Enter') {
                     return
                  } howToUSEClick()
               }}>
                  <div className='icon howtouse'> </div>
                  <div className='text'>{howToUSE ?? 'How to use'}</div>
               </div>
               {orentation === 0 ? <Howtousenew data={uiDataList.ui} /> : <HowToUse data={uiDataList.ui} closeHandle={closeHandleMenu} />}
               {
                  ((window.mob || window.isipad) && window.innerWidth < window.innerHeight) ?

                     <div className="accordion_ProductType portraitButton1" id='accordion_ProductType'>
                        <div className='d-flex'>
                           <span className="portraitButtonText" id="select_type1">{productType && productType[0] ? productType[0]?.mobileTitle : 'Product Type'}</span>
                        </div>
                        <ul className='portraitButtonProducttypeMenu'>
                           {
                              productType[0] && productType[0].items.map((item, index) => {
                                 return (
                                    <React.Fragment key={item.id}>
                                       <li className="subMenuBtn radioButton mob" id={`menu_id_${item.id}`} onClick={e => handleMenuClick(item, e)}>
                                          <label>  <input type="radio" value="product1" /></label>
                                          <span className='mobRadioTitle'>  {item.mobileTitle} </span>
                                       </li>
                                    </React.Fragment>
                                 )
                              })

                           }
                        </ul>
                     </div> : null

               }
               <div className='accordionContainer'>
                  {
                     ((window.mob || window.isipad) && window.innerWidth < window.innerHeight) ? menuList.filter(list => list.id != "ProductType").map((list) => {

                        return (
                           <React.Fragment key={list.id}>
                              {list.id === 'btnXR-ipad' && window.isipad && orentation === 90 ?
                                 <div id={`btnXR-ipad`} tabIndex="1" className='menu' key={list.id} >
                                    <div className={`icon ${list.id}`} ></div>
                                    <div className='text'>{list.title} {list.title}</div>
                                 </div> : list.id !== 'btnXR-ipad' && <div id={`accordion_${list.id}`} tabIndex="1" className='menu' onClick={data1.method} onKeyDown={(e) => {
                                    if (e.key !== 'Enter') {
                                       return
                                    } accordionMenu(e)
                                 }}>
                                    <>
                                       <div className={`icon ${list.id}`} style={{ backgroundImage: `url('${list.icon}')` }}></div>
                                       <div className={`mob_icon mob_icon_${list.id}`}></div>
                                       <div className='text'>{(!window.mob && window.innerWidth > window.innerHeight) && orentation === 90 ? list.title : list.mobileTitle}</div>
                                       <div className='dds__side-nav__group__chevron'><svg viewBox="0 0 32 32" className="dds__side-nav__group__chevron" aria-hidden="true" focusable="false"><path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path></svg></div>
                                    </>
                                 </div>
                              }
                              {list.items && list.items.menuVisibility !== "hide" &&
                                 <SubmenuList
                                    subMenuList={list.items}
                                    orentation={orentation}
                                    handleMenuClick={handleMenuClick}
                                    updatefeatureType={updatefeatureType}
                                 // updateProductId={updateProductId}
                                 />}
                           </React.Fragment>
                        )
                     })


                        :
                        menuList.map((list) => {
                           // console.log(list,'list----')
                           return (
                              <React.Fragment key={list.id}>
                                 {list.id === 'btnXR-ipad' && window.isipad && orentation === 90 ?
                                    <div id={`btnXR-ipad`} tabIndex="1" className='menu' key={list.id} >
                                       <div className={`icon ${list.id}`} ></div>
                                       <div className='text'>{list.title} {list.title}</div>
                                    </div> : list.id !== 'btnXR-ipad' && <div id={`accordion_${list.id}`} tabIndex="-1" className='menu' onClick={data1.method} onKeyDown={(e) => {
                                       if (e.key !== 'Enter') {
                                          return
                                       } accordionMenu(e)
                                    }}>
                                       <>
                                          <div className={`icon ${list.id}`} style={{ backgroundImage: `url('${list.icon}')` }}></div>
                                          <div className={`mob_icon mob_icon_${list.id}`}></div>
                                          <div className='text'>{(!window.mob && window.innerWidth > window.innerHeight) && orentation === 90 ? list.title : list.mobileTitle}</div>
                                          <div className='dds__side-nav__group__chevron'><svg viewBox="0 0 32 32" className="dds__side-nav__group__chevron" aria-hidden="true" focusable="false"><path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path></svg></div>
                                       </>
                                    </div>
                                 }
                                 {list.items && list.items.menuVisibility !== "hide" && <SubmenuList subMenuList={list.items} orentation={orentation} handleMenuClick={handleMenuClick} />}
                              </React.Fragment>
                           )
                        })

                  }
               </div>
               <div id="menuFooter">
                  {myJson.QRSupport && <div id="qrCode">
                     <QRCode
                                                         size={130}
                                                         value={window.linkForGenerateQR}
                                                         style={{height:"auto"}}
                                                         className='qrImage'
                                                         aria-hidden="true"
                                                         aria-label='qr code image'
                                                         /> 
                     <span className='text'> {QR !== undefined ? QR : 'Scan QR code with your mobile device to view the product in your space'}</span>
                  </div>
                  }
                  <div id="animation">
                     <span>{ReduceTransitions !== undefined ? ReduceTransitions : 'Reduce Transitions'}</span>
                     <label className="switch" tabIndex="1" id="animswtich" onKeyPress={handleTransitionskeyPress} >
                        <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="animSwitchValue" type="checkbox" onChange={handleTransitions} defaultChecked={true} />
                        <span className="tabIndexStyle slider round" ></span>
                        <span className="onOff"></span>
                     </label>
                  </div>
                  {ReactDOM.createPortal(
                     <div id="onScreenControl" className='tooltip'>
                        <span className=''>{onScreenControls ?? 'On-Screen Controls'}
                           <span className="tooltiptext">{hovertext ?? 'Click to toggle controls on/off'}</span>
                        </span>
                        <label className="switch" tabIndex="-1" id="onScreenControls" onKeyPress={conScreenControlHandlerkeyPress}>
                           <input tabIndex="-1" className="tabIndexStyle" name='animationOnOff' id="onScreenControlsValue" type="checkbox" onChange={conScreenControlHandler} />
                           <span className="tabIndexStyle slider round" ></span>
                           <span className="onOff"></span>
                        </label>
                     </div>, document.getElementById('onScreenControlContainer'))}
               </div>
               <button className='expandColapsBtn' onClick={menuExpandCollaps}></button>
            </div>
            <FooterControl data={uiDataList.ui} onPrevious={onPreviousMode} onNext={onNextMode} onReset={onReset} closeHandle={closeHandleMenu} />
         </div>
      </>
   );
}

export default Menu;